import React, { useRef, useState } from "react";
import Copy from "../../../../../../../assets/icon/svg/copy";
import Edit from "../../../../../../../assets/icon/svg/edit";
import ThreeDots from "../../../../../../../assets/icon/svg/three-dots";
import Trash from "../../../../../../../assets/icon/svg/trash";
import { getTemporaryBlockId } from "../../../../../../../services/helpers/Helper";

const Block = (props) => {
   const ref = useRef(null);
   const {
      block,
      isSelected,
      onChangeBlockTitle,
      onSelectFaq,
      onCopyBlock,
      onDeleteBlock
   } = props;
   const [isEdit, setIsEdit] = useState(false);

   const handleEdit = () => {
      setIsEdit(true);
      setTimeout(() => {
         ref.current.focus();
      }, 100);
   }


   return (
      <div className={`blocks-navigation-item-wrapper flex-display-row ${isSelected && "is_selecting"} ${isEdit && "is_editing"}`} onClick={() => onSelectFaq(block)}>
         {isEdit ?
            <React.Fragment>
               <div draggable="false"></div>
               <div>
                  <div className="input-text input-text-none-scrollbar text-single font-size-14">
                     <input
                        ref={ref}
                        type="text"
                        onBlur={() => setIsEdit(false)}
                        onChange={(e) => onChangeBlockTitle(getTemporaryBlockId(block), e.target.value)}
                        value={block.title} />
                  </div>
               </div>
               <div></div>
            </React.Fragment>
            :
            <React.Fragment>
               <div className="drag-tool" draggable="true">
                  <ThreeDots />
                  <ThreeDots />
               </div>
               <div>{block.title}</div>
               <div>
                  {onChangeBlockTitle && <a onClick={handleEdit}><Edit /></a>}
                  {onCopyBlock && <a onClick={() => onCopyBlock(block)}><Copy /></a>}
                  {onDeleteBlock && <a onClick={() => {
                     if (window.confirm(`Bạn đang thực hiện việc xóa nội dung "${block.title}". Hoàn tất? `)) {
                        onDeleteBlock(getTemporaryBlockId(block));
                     }
                  }}><Trash /></a>}
               </div>
            </React.Fragment>}
      </div>
   )
}

export default Block;